import React from 'react';
import { Helmet } from 'react-helmet';


const MetaTitle = () => {
  return (
    <div>
      <Helmet>
        <title>TechTotalers</title>
        <meta name="description" content="Learn more about our company and team." />
        <meta name="keywords" content="about, company, team" />
      </Helmet>

      <h1>About Us Phani</h1>
      <p>Welcome to our about page!</p>
    </div>
  );
};

export default MetaTitle;